import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Hubx from "./HubX";
import Fedx from "./Fedx";
import logOverwrite from "./helpers/log";
import pushNotification from "./pushNotification";
import "./style.css";
import Timer from "./timer";
import { GLOBAL_REFRESH_TIMER } from "./core/constants/appGlobals";
import { EVENT_TOKEN_RENEW_TICK } from "./Events";
import Runtime from "./helpers/Runtime";

/** *** GLOBAL CONFIGURATION *** **/
/** * HUBX CONFIGURATION * **/
window.Hubx = new Hubx();
new Fedx().build(window.Hubx);

declare global {
  interface Window {
    Timer: Timer;
  }
}

/** Timers **/
window.Timer = new Timer(window.Hubx);
window.Timer.start(GLOBAL_REFRESH_TIMER, EVENT_TOKEN_RENEW_TICK); // Defines the autoupdate interval of the application, in milliseconds.

/* Log Config */
logOverwrite();

/* Notification */
try {
  pushNotification();
} catch (err) {
  // eslint-disable-next-line no-console
  console.log(err);
}

ReactDOM.render(<>{<App />}</>, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// const runtime = new Runtime();
// if (runtime.isMobile()) {
//   serviceWorker.register();
// } else {
//   serviceWorker.unregister();
// }
